import nikkenImage3 from "../assets/images/expertise/nikken-sekkei/image3.png";
import nikkenImage4 from "../assets/images/expertise/nikken-sekkei/image4.png";

import gensler2 from "../assets/images/firm/Gensler/image2.jpeg";
import gensler5 from "../assets/images/firm/Gensler/image5.jpeg";
import gensler6 from "../assets/images/firm/Gensler/gensler3.jpeg";
import gensler7 from "../assets/images/firm/Gensler/gensler4.jpeg";
import gensler8 from "../assets/images/firm/Gensler/gensler5.jpeg";
import gensler10 from "../assets/images/firm/Gensler/gensler7.jpeg";
import gensler11 from "../assets/images/firm/Gensler/gensler8.jpeg";

import niken2 from "../assets/images/firm/niken/niken2.jpeg";
import niken3 from "../assets/images/firm/niken/niken3.jpeg";
import niken4 from "../assets/images/firm/niken/niken4.jpeg";
import niken5 from "../assets/images/firm/niken/niken5.jpeg";
import niken6 from "../assets/images/firm/niken/niken6.jpeg";

import arcadis1 from "../assets/images/firm/arcadis/arcadis.jpeg";
import arcadis2 from "../assets/images/firm/arcadis/arcadis1.jpeg";
import arcadis3 from "../assets/images/firm/arcadis/arcadis2.jpeg";
import arcadis4 from "../assets/images/firm/arcadis/arcadis3.jpeg";
import arcadis5 from "../assets/images/firm/arcadis/arcadis4.jpeg";
import arcadis6 from "../assets/images/firm/arcadis/arcadis5.jpeg";
import arcadis7 from "../assets/images/firm/arcadis/arcadis6.jpeg";

import hdr1 from "../assets/images/firm/hdr/hdr.jpeg";
import hdr2 from "../assets/images/firm/hdr/hdr1.jpeg";
import hdr4 from "../assets/images/firm/hdr/hdr3.jpeg";
import hdr5 from "../assets/images/firm/hdr/hdr4.jpeg";
import hdr6 from "../assets/images/firm/hdr/hdr5.jpeg";
import hdr7 from "../assets/images/firm/hdr/hdr6.jpeg";
import hdr8 from "../assets/images/firm/hdr/hdr7.jpeg";
import hdr9 from "../assets/images/firm/hdr/hdr8.jpeg";

import aecom2 from "../assets/images/firm/aecom/aecom1.jpeg";
import aecom5 from "../assets/images/firm/aecom/aecom4.jpeg";
import aecom6 from "../assets/images/firm/aecom/aecom5.jpeg";
import aecom7 from "../assets/images/firm/aecom/aecom6.jpeg";
import aecom8 from "../assets/images/firm/aecom/aecom7.jpeg";
import aecom9 from "../assets/images/firm/aecom/aecom8.jpeg";
import aecom10 from "../assets/images/firm/aecom/aecom9.jpeg";

import skidmore1 from "../assets/images/firm/skidmore/skidmore.jpeg";
import skidmore2 from "../assets/images/firm/skidmore/skidmore1.jpeg";
import skidmore3 from "../assets/images/firm/skidmore/skidmore2.jpeg";
import skidmore5 from "../assets/images/firm/skidmore/skidmore4.jpeg";
import skidmore6 from "../assets/images/firm/skidmore/skidmore5.jpeg";
import skidmore7 from "../assets/images/firm/skidmore/skidmore6.jpeg";
import skidmore8 from "../assets/images/firm/skidmore/skidmore7.jpeg";
import skidmore9 from "../assets/images/firm/skidmore/skidmore8.jpeg";

import perkins1 from "../assets/images/firm/perkins/perkins.jpeg";
import perkins2 from "../assets/images/firm/perkins/perkins1.jpeg";
import perkins3 from "../assets/images/firm/perkins/perkins2.jpeg";
import perkins4 from "../assets/images/firm/perkins/perkins3.jpeg";
import perkins5 from "../assets/images/firm/perkins/perkins4.jpeg";
import perkins8 from "../assets/images/firm/perkins/perkins7.jpeg";
import perkins9 from "../assets/images/firm/perkins/perkins8.jpeg";
import perkins10 from "../assets/images/firm/perkins/perkins9.jpeg";

import foster from "../assets/images/firm/foster/foster.jpeg";
import foster1 from "../assets/images/firm/foster/foster1.jpeg";
import foster3 from "../assets/images/firm/foster/foster3.jpeg";
import foster4 from "../assets/images/firm/foster/foster4.jpeg";
import foster5 from "../assets/images/firm/foster/foster5.jpeg";
import foster6 from "../assets/images/firm/foster/foster6.jpeg";
import foster7 from "../assets/images/firm/foster/foster7.jpeg";

// Expertise data for each architecture firm
export const expertiseData = {
  fosterPartners: {
    id: "foster-partners",
    name: "Foster + Partners",
    url: "/firms/foster-partners",
    founded: "1967",
    headquarters: "London, UK",
    description:
      "Global studio for sustainable architecture, urbanism, and design led by Sir Norman Foster.",
    overview:
      "Foster + Partners, founded in 1967 by Sir Norman Foster, reported a turnover over £400 million (~$530 million USD) in 2024, with around 1,900 staff globally.",
    heroImage: foster1,
    keyProjects: [
      {
        title: "Apple Park, Cupertino",
        slug: "apple-park-cupertino",
        image: foster5,
        description:
          "A 175‑acre, LEED Platinum ring-shaped campus powered by renewables.",
      },
      {
        title: "30 St Mary Axe (The Gherkin), London",
        slug: "30-st-mary-axe-the-gherkin-london",
        image: foster3,
        description:
          "Aerodynamic commercial skyscraper in London's financial district.",
      },
      {
        title: "Millau Viaduct, France",
        slug: "millau-viaduct-france",
        image: foster4,
      },
      {
        title: "Hearst Tower, New York",
        slug: "hearst-tower-new-york",
        image: foster7,
      },
      {
        title: "Reichstag renovation, Berlin",
        slug: "reichstag-renovation-berlin",
      },
    ],
    featuredProject: {
      title: "Apple Park",
      slug: "apple-park",
      image: foster1,
      description:
        "LEED Platinum campus with a landscaped circular design and largest curved glass panels.",
    },
    expertise: [
      {
        title: "High-Tech Sustainable Design",
        description:
          "Merging advanced engineering with ecological responsibility.",
        image: foster6,
        details:
          "Integrates systems like structural glazing and energy harvesting in landmark architecture.",
      },
      {
        title: "Iconic Landmarks & Infrastructure",
        description: "Creating globally recognized structures.",
        image: foster,
        details:
          "From towers to bridges, their work merges technical ingenuity with civic impact.",
      },
    ],
  },

  gensler: {
    id: "gensler",
    name: "Gensler",
    url: "/firms/gensler",
    founded: "1965",
    headquarters: "San Francisco, USA",
    description:
      "Global architecture, design, and planning firm with 53 offices and 5,500+ employees.",
    overview:
      "Gensler is the world's largest architecture firm by revenue, generating approximately $1.785 billion USD in 2022 and employing over 5,500 professionals across 53 offices in 17 countries :contentReference[oaicite:2]{index=2}. The firm serves clients in more than 100 countries, delivering transformative workplace, urban design, and civic architecture.",
    heroImage: gensler8,
    keyProjects: [
      {
        title: "San Francisco International Airport Terminal 2",
        slug: "san-francisco-international-airport-terminal-2",
        image: gensler7,
        description:
          "China's tallest building and the world's second-tallest, featuring a unique spiral form and sustainable design elements.",
      },
      {
        title: "San Francisco International Airport Terminal 2",
        slug: "san-francisco-international-airport-terminal-2-2",
        image: gensler6,
        description: "A modern, sustainable airport terminal in San Francisco.",
      },
      {
        title: "The Shard, London",
        slug: "the-shard-london",
        image: gensler10,
      },
      {
        title: "JetBlue Terminal 5",
        slug: "jetblue-terminal-5",
        image: gensler11,
      },
    ],
    featuredProject: {
      title: "Meta Headquarters – Menlo Park, California",
      slug: "meta-headquarters-menlo-park-california",
      image: gensler8,
      description:
        "Meta's main headquarters, designed by Frank Gehry and developed in part with Gensler, is known as MPK21. It emphasizes sustainability, collaboration, and open design.",
    },
    expertise: [
      {
        title: "Workplace Design",
        description:
          "Innovative environments that enhance productivity and well-being.",
        image: gensler5,
        details:
          "Designing offices that foster collaboration, flexibility, and employee health.",
      },
      {
        title: "Urban Planning",
        description: "Creating sustainable, resilient urban spaces.",
        image: gensler2,
        details:
          "Masterplanning cities and districts with integrated environmental, social, and economic strategies.",
      },
    ],
  },

  nikkenSekkei: {
    id: "nikken-sekkei",
    name: "Nikken Sekkei",
    url: "/firms/nikken-sekkei",
    founded: "1900",
    headquarters: "Tokyo, Japan",
    description:
      "Japan's largest architecture firm, known for sustainable urban development.",
    overview:
      "Founded in 1900, Nikken Sekkei is Japan's largest architecture and engineering firm. As of April 2024, it employs around 2,470 staff domestically, plus additional global teams (total ~2,700), and reported net revenues of ¥59.4 billion JPY in 2023 (≈ $400 m) :contentReference[oaicite:3]{index=3}. The firm has delivered 20,000+ projects in over 50 countries.",
    heroImage: niken6,
    keyProjects: [
      {
        title: "Shanghai World Financial Center, China",
        slug: "shanghai-world-financial-center-china",
        image: niken5,
        description:
          "The world's tallest broadcasting tower, combining traditional Japanese aesthetics with cutting-edge technology.",
      },
      {
        title: "Osaka Station City, Osaka",
        slug: "osaka-station-city-osaka",
        image: niken4,
        description:
          "A major railway station and commercial complex in Osaka, Japan.",
      },
      {
        title: "Tokyo Skytree, Tokyo",
        slug: "tokyo-skytree-tokyo",
        image: niken2,
        description:
          "A supertall skyscraper located in the Pudong district of Shanghai, China.",
      },
      {
        title: "Osaka Station City, Osaka",
        slug: "osaka-station-city-osaka-2",
        image: niken3,
        description: "A venue for gymnastics events in Tokyo, Japan.",
      },
    ],
    featuredProject: {
      title: "Shanghai World Financial Center",
      slug: "shanghai-world-financial-center",
      image: niken6,
      description:
        "Shanghai World Financial Center (SWFC) is a supertall, mixed-use skyscraper located in Shanghai's Pudong district.",
    },
    expertise: [
      {
        title: "Sustainable Urban Development",
        description: "Resilient urban environments with cultural sensitivity.",
        image: niken2,
        details:
          "Combines urban planning, transportation, and landscape design to create vibrant, low-impact cities.",
      },
      {
        title: "Smart & Integrated Design",
        description:
          "Combining architecture, MEP, structure, and digital tech.",
        image: niken3,
        details:
          "In-house BIM, computation, and IoT-led workflows deliver precise, performance-driven buildings.",
      },
      {
        title: "Cultural Context Integration",
        description:
          "Blending Japanese architectural traditions with modern innovation.",
        image: nikkenImage3,
        details:
          "Designs reflect Japanese aesthetics while meeting global functional needs.",
      },
      {
        title: "Urban Infrastructure Planning",
        description: "Holistic civil engineering for dense cities.",
        image: nikkenImage4,
        details:
          "Weave transportation, utilities, and public realm solutions into coherent urban systems.",
      },
    ],
  },

  arcadis: {
    id: "arcadis",
    name: "Arcadis",
    url: "/firms/arcadis",
    founded: "1888",
    headquarters: "Amsterdam, Netherlands",
    description:
      "Leading global design, engineering & consultancy firm ranked #2 in WA100 2025.",
    overview:
      "Arcadis ranks #2 in the 2025 World Architecture 100 list, with a turnover of €370–379 m in architecture revenue and 1,956 architects on staff :contentReference[oaicite:4]{index=4}. Formed through acquisitions of IBI Group and CallisonRTKL, Arcadis delivers intelligent, sustainable design worldwide.",
    heroImage: arcadis1,
    keyProjects: [
      {
        title: "Saks Fifth Avenue, Beverly Hills",
        slug: "saks-fifth-avenue-beverly-hills",
        image: arcadis4,
        description: "A luxury department store in Beverly Hills, California.",
      },
      {
        title: "The Curv, Utah",
        slug: "the-curv-utah",
        image: arcadis3,
        description: "A modern residential building in Utah.",
      },
      {
        title: "Dyson Cancer Centre",
        slug: "dyson-cancer-centre",
        image: arcadis5,
        description: "A state-of-the-art cancer treatment center.",
      },
      {
        title: "Doha Metro, Qatar",
        slug: "doha-metro-qatar",
        image: arcadis1,
        description: "A rapid transit system in Doha, Qatar.",
      },
    ],
    featuredProject: {
      title: "The Edge, Amsterdam",
      slug: "the-edge-amsterdam",
      image: arcadis2,
      description:
        "A highly sustainable office building in Amsterdam, known for its smart technology and energy efficiency.",
    },
    expertise: [
      {
        title: "Sustainable Buildings",
        description: "Energy-efficient, innovative building design.",
        image: arcadis6,
        details:
          "Combines design excellence, decarbonisation strategies, and deep retrofits.",
      },
      {
        title: "Sustainable Buildings",
        description: "Energy-efficient, innovative building design.",
        image: arcadis7,
        details:
          "Combines design excellence, decarbonisation strategies, and deep retrofits.",
      },
    ],
  },

  hdr: {
    id: "hdr",
    name: "HDR (Henningson, Durham & Richardson)",
    url: "/firms/hdr",
    founded: "1917",
    headquarters: "Omaha, USA",
    description:
      "Architecture, engineering, environmental, and consulting firm operating in 60+ countries.",
    overview:
      "HDR is an international architecture, engineering, and environmental consultancy with revenue estimated at $700–800 m and operations in over 60 countries. It focuses on healthcare, science & technology, and infrastructure sectors :contentReference[oaicite:5]{index=5}.",
    heroImage: hdr1,
    keyProjects: [
      {
        title: "San Ysidro Land Port of Entry",
        slug: "san-ysidro-land-port-of-entry",
        image: hdr6,
        description:
          "A leading healthcare facility in Phoenix, Arizona, designed for innovation and patient care.",
      },
      {
        title: "San Ysidro Land Port of Entry",
        slug: "san-ysidro-land-port-of-entry-2",
        image: hdr7,
        description: "A major international airport in Texas, USA.",
      },
      {
        title: "Dallas/Fort Worth International Airport",
        slug: "dallas-fort-worth-international-airport",
        image: hdr8,
        description:
          "A tunnel project replacing the Alaska Way Viaduct in Seattle.",
      },
      {
        title: "San Ysidro Land Port of Entry",
        slug: "san-ysidro-land-port-of-entry-3",
        image: hdr9,
        description: "A world-renowned research hospital for children.",
      },
    ],
    featuredProject: {
      title: "Banner University Medical Center",
      slug: "banner-university-medical-center",
      image: hdr2,
      description:
        "A leading healthcare facility in Phoenix, Arizona, designed for innovation and patient care.",
    },
    expertise: [
      {
        title: "Healthcare & Research Design",
        description: "Complex medical facilities with advanced integration.",
        image: hdr4,
        details:
          "Leaders in evidence-based design for health and lab environments.",
      },
      {
        title: "Healthcare & Research Design",
        description: "Complex medical facilities with advanced integration.",
        image: hdr5,
        details:
          "Leaders in evidence-based design for health and lab environments.",
      },
    ],
  },

  aecom: {
    id: "aecom",
    name: "AECOM",
    url: "/firms/aecom",
    founded: "1990",
    headquarters: "Dallas, USA",
    description:
      "Global infrastructure consulting firm, ranked #2 in ENR 2025 global design list.",
    overview:
      "AECOM, ranked #2 on ENR's 2025 list of global design firms, delivers integrated architecture, engineering, and construction services. Known for infrastructure megaprojects including airports, transit, and urban masterplans :contentReference[oaicite:6]{index=6}.",
    heroImage: aecom10,
    keyProjects: [
      {
        title: "Hong Kong–Zhuhai–Macau Bridge, China",
        slug: "hong-kong-zhuhai-macau-bridge-china",
        image: aecom8,
        description:
          "A symbol of resilience and renewal in New York City, this skyscraper is the tallest building in the Western Hemisphere.",
      },
      {
        title: "LAX Modernization, USA",
        slug: "lax-modernization-usa",
        image: aecom6,
        description: "A major railway project in London, UK.",
      },
      {
        title: "Crossrail (Elizabeth line), London",
        slug: "crossrail-elizabeth-line-london",
        image: aecom5,
        description:
          "A large-scale modernization project for Los Angeles International Airport.",
      },
      {
        title: "Abu Dhabi International Airport, UAE",
        slug: "abu-dhabi-international-airport-uae",
        image: aecom10,
        description:
          "A series of bridges and tunnels connecting Hong Kong, Macau, and Zhuhai.",
      },
    ],
    featuredProject: {
      title: "One World Trade Center",
      slug: "one-world-trade-center",
      image: aecom2,
      description:
        "A symbol of resilience and renewal in New York City, this skyscraper is the tallest building in the Western Hemisphere.",
    },
    expertise: [
      {
        title: "Infrastructure & Transportation",
        description: "Complex, multi-modal infrastructure solutions.",
        image: aecom7,
        details:
          "Expertise spans transit hubs, bridges, highways, and urban infrastructure.",
      },
      {
        title: "Infrastructure & Transportation",
        description: "Complex, multi-modal infrastructure solutions.",
        image: aecom9,
        details:
          "Expertise spans transit hubs, bridges, highways, and urban infrastructure.",
      },
    ],
  },

  som: {
    id: "som",
    name: "Skidmore, Owings & Merrill (SOM)",
    url: "/firms/som",
    founded: "1936",
    headquarters: "Chicago, USA",
    description:
      "Renowned architecture, engineering, and urban planning firm famous for iconic skyscrapers.",
    overview:
      "Founded in 1936, SOM is world-renowned for pioneering skyscraper and structural engineering innovation. Projects include Burj Khalifa, One World Trade Center, Willis Tower, and cutting-edge emergency infrastructure :contentReference[oaicite:7]{index=7}.",
    heroImage: skidmore2,
    keyProjects: [
      {
        title: "Burj Khalifa, Dubai",
        slug: "burj-khalifa-dubai",
        image: skidmore3,
        description:
          "The world's tallest building, an architectural and engineering marvel located in Dubai.",
      },
      {
        title: "Willis Tower, Chicago",
        slug: "willis-tower-chicago",
        image: skidmore5,
        description:
          "A symbol of resilience and renewal in New York City, this skyscraper is the tallest building in the Western Hemisphere.",
      },
      {
        title: "Two Manhattan West, New York",
        slug: "two-manhattan-west-new-york",
        image: skidmore6,
        description: "A 110-story skyscraper in Chicago, Illinois.",
      },
      {
        title: "Two Manhattan West, New York",
        slug: "two-manhattan-west-new-york-2",
        image: skidmore7,
        description: "A modern office tower in New York City.",
      },
    ],
    featuredProject: {
      title: "Burj Khalifa",
      slug: "burj-khalifa",
      image: skidmore1,
      description:
        "The world's tallest building, an architectural and engineering marvel located in Dubai.",
    },
    expertise: [
      {
        title: "Super-Tall Building Design",
        description: "Innovative skyscraper engineering and design.",
        image: skidmore8,
        details:
          "Pioneers of high-rise, mixed-use developments and resilient infrastructure.",
      },
      {
        title: "Super-Tall Building Design",
        description: "Innovative skyscraper engineering and design.",
        image: skidmore9,
        details:
          "Pioneers of high-rise, mixed-use developments and resilient infrastructure.",
      },
    ],
  },

  perkinsWill: {
    id: "perkins-will",
    name: "Perkins + Will",
    url: "/firms/perkins-will",
    founded: "1935",
    headquarters: "Chicago, USA",
    description:
      "Global architecture and design firm committed to sustainable, human‑centric design.",
    overview:
      "Perkins + Will, founded in 1935 and headquartered in Chicago with 25 global studios, generates around $700 m in revenue. The firm is recognized for its sustainable, equitable design in healthcare, education, and public spaces :contentReference[oaicite:8]{index=8}.",
    heroImage: perkins1,
    keyProjects: [
      {
        title: "Vancouver Convention Centre, Canada",
        slug: "vancouver-convention-centre-canada",
        image: perkins9,
        description:
          "A LEED Platinum-certified convention center in Vancouver, featuring a 6-acre living roof and innovative sustainable design strategies.",
      },
      {
        title: "Shanghai Natural History Museum, China",
        slug: "shanghai-natural-history-museum-china",
        image: perkins3,
        description:
          "A world-class museum in Shanghai, China, known for its sustainable design.",
      },
      {
        title: "Shanghai Natural History Museum",
        slug: "shanghai-natural-history-museum",
        image: perkins4,
        description: "A leading medical center in Chicago, Illinois.",
      },
      {
        title: "Destination Crenshaw",
        slug: "destination-crenshaw",
        image: perkins5,
        description:
          "A state-of-the-art biosciences research facility at Georgia Tech.",
      },
    ],
    featuredProject: {
      title: "Vancouver Convention Centre",
      slug: "vancouver-convention-centre",
      image: perkins2,
      description:
        "A LEED Platinum-certified convention center in Vancouver, featuring a 6-acre living roof and innovative sustainable design strategies.",
    },
    expertise: [
      {
        title: "Regenerative & Equitable Design",
        description:
          "Designing spaces that promote social and environmental well-being.",
        image: perkins8,
        details:
          "Beyond sustainability, firm focuses on equity, wellness, and climate-responsive architecture.",
      },
      {
        title: "Regenerative & Equitable Design",
        description:
          "Designing spaces that promote social and environmental well-being.",
        image: perkins10,
        details:
          "Beyond sustainability, firm focuses on equity, wellness, and climate-responsive architecture.",
      },
    ],
  },
};

// Helper function to get firm data
export const getFirmData = (firmId) => {
  return expertiseData[firmId] || null;
};

// Helper function to get all firms
export const getAllFirms = () => {
  return Object.entries(expertiseData).map(([id, data]) => ({
    id,
    ...data,
  }));
};

// Helper function to get firm by URL
export const getFirmByUrl = (url) => {
  return Object.values(expertiseData).find((firm) => firm.url === url) || null;
};

// Helper function to get related firms
export const getRelatedFirms = (currentFirmId, count = 3) => {
  const allFirms = getAllFirms();
  return allFirms.filter((firm) => firm.id !== currentFirmId).slice(0, count);
};

// Helper function to get project by firm and project slug
export const getProjectBySlugs = (firmSlug, projectSlug) => {
  const firm = Object.values(expertiseData).find(f => f.id === firmSlug);
  if (!firm) return null;
  // Search keyProjects
  const project = (firm.keyProjects || []).find(p => p.slug === projectSlug);
  if (project) return project;
  // Check featuredProject
  if (firm.featuredProject && firm.featuredProject.slug === projectSlug) {
    return firm.featuredProject;
  }
  return null;
};
